import { FC, useState } from "react";
import { Skeleton } from "@mui/material";
import { isEmpty } from "lodash";
import __ from "src/utils/Translations";
import CalendarsEmpty from "src/Pages/Company/Absences/Calendars/CalendarsEmpty";
import ErrorDataFetching from "src/Components/Error/ErrorDataFetching";
import { ICalendarList, ISortedCalendars } from "./Calendars.models";
import CalendarsListCategory from "./CalendarsListCategory";

interface ICalendarsListProps {
  data: ICalendarList;
  isFetching: boolean;
  isError: boolean;
}

const CalendarsList: FC<ICalendarsListProps> = ({
  data,
  isFetching,
  isError,
}) => {
  if (isFetching)
    return Array.from(new Array(3)).map((item) => (
      <Skeleton
        variant="rectangular"
        height={60}
        sx={{
          marginBottom: "2rem",
        }}
      />
    ));

  if (isError) return <ErrorDataFetching />;

  if (isEmpty(data)) return <CalendarsEmpty />;

  return Object.entries(data).map(([category, years]) => (
    <CalendarsListCategory
      key={category}
      category={category}
      data={years as ISortedCalendars}
      isFetching={isFetching}
    />
  ));
};

export default CalendarsList;
